// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__2nI_B","textArea":"TextArea_textArea__fp9zv","characterCount":"TextArea_characterCount__GCUGM"};